import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServicePathProviderService } from '@blk/cwp-ng-framework';
import { WebUserDataConstants } from '@ddt-web/domain';
import { of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { PeConfigKey, SharedConfigKey } from '../constants/config-key.constants';
import { InjectConfig } from '../decorators/config.decorator';
import { mapPortfolioTagResponseToPortfolioTagConfig } from '../mappings/portfolio-tag-response-mappings';
import { PortfolioTagConfigResponse } from '../models/portfolio-tag-config-response.model';
import { PortfolioTagConfig } from '../models/portfolio-tag-config.model';
import { SupportedPortfolioTag } from '../models/supported-portfolio-tags.model';

@Injectable({
	providedIn: 'root'
})
export class PortfolioTagsConfigService {
	@InjectConfig(SharedConfigKey.SUPPORTED_PORTFOLIO_TAGS) public readonly supportedPortfolioTags: SupportedPortfolioTag[] = [];
	@InjectConfig(PeConfigKey.PORTFOLIO_TYPE_OPTIONS) public readonly configPortfolioTypeOptions: string[] = [];

	private portfolioTagConfig: PortfolioTagConfig;

	constructor(
		private http: HttpClient,
		private servicePathProvider: ServicePathProviderService
	) { }

	public init(): Promise<PortfolioTagConfig> {
		if (this.portfolioTagConfig) {
			return of(this.portfolioTagConfig).toPromise();
		} else {
			const url: string = this.servicePathProvider.getServicePath('api-gateway') + WebUserDataConstants.PORTFOLIO_TAGGING_CONFIG;
			return this.http.get<PortfolioTagConfigResponse>(url).pipe(
				map(response => mapPortfolioTagResponseToPortfolioTagConfig(response, this.supportedPortfolioTags, this.configPortfolioTypeOptions)),
				tap(portfolioTagConfig =>
					this.portfolioTagConfig = portfolioTagConfig
				),
				catchError(error => {
					console.error('Error occurred retrieving portfolio tagging config:', error);
					return of(error);
				})).toPromise();
		}
	}

	public getPortfolioTagConfig(): PortfolioTagConfig {
		return this.portfolioTagConfig;
	}
}
